var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiteSpapOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#d6d7e2",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-125.407 -66.623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.975,45.821a6.612,6.612,0,0,1-9.374,0L5.282,40.467a6.705,6.705,0,0,1,0-9.433l1.793-1.8,9.146,9.2,4.237-4.262-9.146-9.2L8.948,22.591,4.71,26.853l-1.793,1.8a10.087,10.087,0,0,0,0,14.19L8.236,48.2a9.946,9.946,0,0,0,14.108,0l8.469-8.934V34.879Z",
    transform: "translate(140 61.575)",
    fill: "#8688a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.012,0l1.12,0L1.12,4.23,0,4.233Z",
    transform: "translate(141.587 84.09) rotate(-45)",
    fill: "#8688a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.012,0l1.12,0L1.12,4.23,0,4.233Z",
    transform: "translate(156.712 101.702) rotate(-45)",
    fill: "#8688a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.012,0l1.12,0L1.12,4.23,0,4.233Z",
    transform: "translate(159.089 99.44) rotate(-45)",
    fill: "#8688a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.012,0l1.12,0L1.12,4.23,0,4.233Z",
    transform: "translate(161.69 96.894) rotate(-45)",
    fill: "#8688a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.012,0l1.12,0L1.12,4.23,0,4.233Z",
    transform: "translate(143.932 81.801) rotate(-45)",
    fill: "#8688a8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteSpapOff);
export default __webpack_public_path__ + "static/media/site-spap-off.53fc1d986296d1321b1a32411b852c14.svg";
export { ForwardRef as ReactComponent };